/**
 * 判断值是否为 null 或 undefined
 * @return 是否为 null 或 undefined
 */
function isNil(value) {
    return value === null || value === undefined;
}

export { isNil as default };
//# sourceMappingURL=is-nil.js.map
